<template>
  <a-textarea
    v-bind="attrs"
    ref="textareaRef"
    :readonly="readonly"
    :maxlength="newMaxlength"
    :class="[
      bem.b(),
      bem.is(isGray ? 'gray-textarea' : ''),
      props.useResize ? bem.is('use-resize') : '',
      props.readonly ? bem.is('readonly') : '',
    ]"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}" />
    </template>
  </a-textarea>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { computed, ref, useAttrs } from 'vue'
import { textareaProps } from './textarea'

defineOptions({ name: 'LlTextarea' })

const attrs = useAttrs()
const bem = createNamespace('textarea')

const props = defineProps(textareaProps)

const textareaRef = ref()

const newMaxlength = computed(() => {
  // 处理 maxlength 最大长度为 0 则不限制
  if (typeof props.maxlength === 'number') {
    return props.maxlength <= 0 ? null : props.maxlength
  }

  return props.maxlength
})

const focus = () => {
  textareaRef.value?.focus?.()
}

defineExpose({ focus })
</script>
